export type PlayerTag = {
  id: string;
  name: string;
};

export type PaymentMethodGeneralLimit = {
  currency: string;
  min: number;
  max: number;
}

export type PaymentMethodExceptionLimit = {
  id?: string;
  currency: string;
  type: number;
  min: number | null;
  max: number | null;
  playerTags: PlayerTag[];
};

export const DEFAULT_EXCEPTION_LIMIT: PaymentMethodExceptionLimit = {
  currency: '',
  type: 1,
  min: null,
  max: null,
  playerTags: [],
};

export type ExtendedPaymentMethodExceptionLimit = PaymentMethodGeneralLimit & {
  limitList: PaymentMethodExceptionLimit[];
}

export type PaymentMethodExceptionLimitCreateModel = {
  currency: string;
  type: number;
  min: number;
  max: number;
  playerTags: string[];
};

export type PaymentMethodExceptionLimitCreateRequestPayload = {
  paymentMethodSettingsId: string;
  paymentMethodExceptionData: PaymentMethodExceptionLimitCreateModel;
};

export type PaymentMethodExceptionLimitDeleteRequestPayload = {
  paymentMethodSettingsId: string;
  exceptionLimitId: string;
};

export type PaymentMethodExceptionLimitUpdateModel = {
  exceptionLimitId: string;
  paymentMethodExceptionData: PaymentMethodExceptionLimitCreateModel;
};

export type PaymentMethodExceptionLimitUpdateRequestPayload = PaymentMethodExceptionLimitCreateRequestPayload & {
  exceptionLimitId: string;
};
